import cx from 'classnames';
import { useIntl } from 'react-intl';

import { SkeletonRectangle } from '../../../design-system/components/skeletons/SkeletonRectangle';
import { Price } from '../../../resources/shared/types/Price';
import { useLocale } from '../../../shared/hooks/useLocale';
import { useCurrency } from '../../../shared/providers/currency/useCurrency';
import { roundedPriceWithCurrencySymbol } from '../../../shared/utilities/priceFormat/priceFormat';

import style from './ItinerariesListTitle.module.css';
import { Sort, SortValue } from './Sort';

type ItinerariesListTitleProps = {
    itinerariesCount: number;
    destinationPreposition: string;
    destinationName: string;
    isLoading: boolean;
    lowestItineraryPrice: Price | null;
    setSort: (sort: SortValue) => void;
};

export const ItinerariesListTitle = ({
    itinerariesCount,
    destinationPreposition,
    destinationName,
    lowestItineraryPrice,
    isLoading,
    setSort,
}: ItinerariesListTitleProps) => {
    const { formatMessage } = useIntl();
    const { locale } = useLocale();
    const { currentCurrency } = useCurrency();

    return (
        <div className={cx(style.titleContainer)}>
            {isLoading ? (
                <SkeletonRectangle width="350px" />
            ) : (
                <h2 className="font-xs-regular">
                    {lowestItineraryPrice
                        ? formatMessage(
                              {
                                  id: 'page.itinerariesList.itineraries.resultsTitleWithLowestPrice',
                              },
                              {
                                  itinerariesCount,
                                  destinationPreposition,
                                  destinationName,
                                  lowestPrice: roundedPriceWithCurrencySymbol({
                                      locale,
                                      currency: currentCurrency,
                                      price: lowestItineraryPrice,
                                  }),
                              },
                          )
                        : formatMessage(
                              {
                                  id: 'page.itinerariesList.itineraries.resultsTitle',
                              },
                              {
                                  itinerariesCount,
                                  destinationPreposition,
                                  destinationName,
                              },
                          )}
                </h2>
            )}
            <Sort onSortSelected={(sort) => setSort(sort)} />
        </div>
    );
};
